import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChargeWaiverContMain from "presentation/view/container/ChargeWaiver/ChargeWaiverContMain";

CommonEntrypoint(<ChargeWaiverContMain/>)